import React from 'react';
import { Coins } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Input } from '@/components/ui/input';

/** Custom-amount Stripe purchase row.
 *  Lets the writer enter any dollar amount inside [min_usd, max_usd] and
 *  previews the equivalent token grant in real time. */
export function CustomAmountRow({ config, isCustom, onSelect, amount, onAmountChange, tokens }) {
  return (
    <>
      <h3 className="mt-5 text-[12px] font-semibold uppercase tracking-wider text-muted-foreground">
        Or buy a custom amount
      </h3>
      <button
        onClick={onSelect}
        data-testid="pkg-custom"
        className={cn(
          'mt-2 flex w-full items-center gap-4 rounded-md border bg-card p-4 text-left transition-all',
          isCustom ? 'border-primary shadow-panel-active' : 'border-border hover:border-primary/50'
        )}
      >
        <div className={cn('flex h-10 w-10 items-center justify-center rounded-md',
          isCustom ? 'bg-primary text-primary-foreground' : 'bg-secondary text-muted-foreground')}>
          <Coins className="h-5 w-5" />
        </div>
        <div className="flex-1">
          <div className="text-[13px] font-semibold">Custom amount</div>
          <div className="text-[11px] text-muted-foreground">
            ${config.min_usd}–${config.max_usd} · {config.tokens_per_usd?.toLocaleString()} tokens / USD
          </div>
        </div>
        <div className="relative w-40">
          <span className="absolute left-2 top-1/2 -translate-y-1/2 text-[12px] text-muted-foreground">$</span>
          <Input
            type="number"
            step="1"
            min={config.min_usd}
            max={config.max_usd}
            placeholder="29"
            disabled={!isCustom}
            value={amount}
            data-testid="pkg-custom-input"
            onChange={(e) => onAmountChange(e.target.value)}
            className="h-9 pl-5 font-mono-stat"
            onClick={(e) => { e.stopPropagation(); onSelect(); }}
          />
        </div>
        {isCustom && tokens > 0 && (
          <div className="text-right text-[11px]">
            <div className="font-mono-stat text-[12.5px] font-semibold text-primary">+{tokens.toLocaleString()}</div>
            <div className="text-muted-foreground">tokens</div>
          </div>
        )}
      </button>
    </>
  );
}
